import '@/app/app.css';
import './subject-big-list.css';

import { Subject } from '@/features/subject/subject';
import { SubjectForm } from '@/features/subject/subject-form/subject-form.js';

import '@/app/app';

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-subject').forEach((element) => new Subject(element));
	window.app.subjectForm = new SubjectForm(document.querySelector('.js-subject-form'));
});
